export default __webpack_public_path__ + "icon-dots.png";